<template>
  <path
    d="M10 9.04024V14.9602C10 15.3802 10.48 15.6102 10.81 15.3502L14.51 12.3902C14.76 12.1902 14.76 11.8102 14.51 11.6102L10.81 8.65024C10.48 8.39024 10 8.62024 10 9.04024ZM19 3.00024H5C3.9 3.00024 3 3.90024 3 5.00024V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00024C21 3.90024 20.1 3.00024 19 3.00024ZM18 19.0002H6C5.45 19.0002 5 18.5502 5 18.0002V6.00024C5 5.45024 5.45 5.00024 6 5.00024H18C18.55 5.00024 19 5.45024 19 6.00024V18.0002C19 18.5502 18.55 19.0002 18 19.0002Z"
  />
</template>
